import { userConstants } from "../_constants";

const host = window.location.host;
let isAlreadyLoggedIn =
  JSON.parse(localStorage.getItem("main-login")) ||
  host === "yslearn.in" ||
  host === "qa.yslearn.in";

const initialState = { mainLogin: isAlreadyLoggedIn ? true : false };

export function mainlogin(state = initialState, action) {
  switch (action.type) {
    case userConstants.MAIN_LOGIN_SUCCESS:
      return { mainLogin: true };
    case userConstants.MAIN_LOGIN_FAILURE:
      return { mainLogin: false };
    default:
      return state;
  }
}
